import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { css } from "styled-components";

Object.assign(quantityOrderedStyles, {
    ...quantityOrderedStyles,
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-top: 10px;
                margin-bottom: 20px;
            `,
            inputSelect: css`
                width: auto;
                border: 1px solid ${CarotekColors.grey10} !important;
                padding: 0 10px 0 10px !important;
            `,
        },
    },
});
